<template>
  <div>
    <form class="modal-form" @keyup.enter="create()">
      <custom-input
        inputType="text"
        placeholder="Должность"
        labelText="Должность"
        v-model="model.people_name"
        :errorMessage="model.validator['people_name']"
        :inputValue="model.people_name"
        name="people_name"
        required
      />

      <custom-input
        inputType="number"
        placeholder="Количество рабочих дней в году"
        labelText="Количество рабочих дней в году"
        v-model="model.days"
        :errorMessage="model.validator['days']"
        :inputValue="model.days"
        name="days"
        required
      />

      <custom-input
        inputType="number"
        placeholder="Значение индивидуального риска в зданиях"
        labelText="Значение индивидуального риска в зданиях"
        v-model="model.base_risk"
        :errorMessage="model.validator['base_risk']"
        :inputValue="model.base_risk"
        name="base_risk"
        required
      />
    </form>

    <div class="modal-footer-buttons">
      <main-button type="button" @click="create()">
        <span v-if="person.id">Сохранить</span><span v-else>Добавить</span>
      </main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import MainButton from "../../../components/ui/MainButton.vue";
import CustomInput from "../../../components/ui/Input.vue";

export default {
  name: "newProject",
  components: {
    MainButton,
    CustomInput,
  },
  props: {
    person: Object,
    project: Object,
  },
  data() {
    return {
      model: {
        people_name: "Работник",
        days: 247,
        base_risk: 0,
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                model: "people_name",
                label: "Должность",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                model: "days",
                label: "Количество рабочих дней в году",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                model: "base_risk",
                label: "Значение индивидуального риска в зданиях",
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  methods: {
    create() {
      this.$set(this.model, "validator", {});
      if (!this.model.id) {
        const data = this.model;
        this.$http
          .post("risk/people/create?proj_id=" + this.project.id, data)
          .then((response) => {
            this.$emit("newPerson", response.data);
          })
          .catch((e) => {
            if (e.response.data) {
              this.$set(this.model, "validator", e.response.data);
            }
          });
      } else {
        const data = this.model;
        this.$http
          .post("risk/people/update?proj_id=" + this.project.id + "&id=" + data.id, data)
          .then((response) => {
            Object.assign(this.person, response.data);
            this.$emit("personClose");
            this.$emit('clearCalculations')
          })
          .catch((e) => {
            if (e.response.data) {
              this.$set(this.model, "validator", e.response.data);
            }
          });
      }
    },
  },
  mounted() {
    if (this.person.id) {
      Object.assign(this.model, this.person);
    }
  },
  watch: {
    person() {
      if (this.person.id) {
        Object.assign(this.model, this.person);
      }
    },
  },
};
</script>
